import React, { useRef } from "react";
import { Progress, Tag, Tooltip } from "antd";
import { FileDoneOutlined, EyeOutlined, EditOutlined, ToolOutlined } from "@ant-design/icons";
import InfoCard from "../../../../Components/InfoCard";
import { ButtonItem } from "../../../../Components/Items";

const avanceDe = (orden) => {
  if (!orden.cantidadEsperada) return 0;
  return Math.round(((orden.cantidadFinal || 0) / orden.cantidadEsperada) * 100);
};

const TarjetaOrdenProduccionPU = ({ orden, onVer, onEditar, onVerEtapas, permisoEditar, permisoMoverPiezas }) => {
  const timeoutRef = useRef(null);
  const tieneConsumo = (orden.consumos || []).some((c) => c.consumido > 0);
  const puedeEditar = permisoEditar && orden.estado === 1 && !tieneConsumo;

  const onClick = () => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => onVer(orden._id), 250);
  };

  const onDoubleClick = () => {
    clearTimeout(timeoutRef.current);
    onVerEtapas(orden._id);
  };

  const detener = (fn) => (e) => {
    e.stopPropagation();
    fn(orden._id);
  };

  return (
  <InfoCard
    title={orden.folio}
    icon={<FileDoneOutlined />}
    iconColor="#1890ff"
    compact
    dense
    span={6}
    xs={24}
    sm={12}
    lg={6}
    className="info-card-clickable"
    onClick={onClick}
    onDoubleClick={onDoubleClick}
    sections={[
      ...(orden.estado === 2 ? [{ span: 24, content: <Tag color="red">Cancelada</Tag> }] : []),
      ...(orden.estado === 3 ? [{ span: 24, content: <Tag color="green">Terminada</Tag> }] : []),
      ...(orden.estado === 1 && orden.faltaInventario
        ? [{ span: 24, content: <Tag color="volcano">Falta inventario</Tag> }]
        : []),
      {
        items: [
          { inline: false, label: "Flujo", value: orden.flujoId?.nombre || "—", marginBottom: 2 },
          { inline: false, label: "Presupuesto", value: orden.presupuestoPUId?.nombre || "—", marginBottom: 2 },
          {
            inline: false,
            label: "Partida / Matriz",
            value: orden.partidaSnapshot?.nombre || (orden.matrices || []).map((m) => m.clave || m.descripcion).join(", ") || "—",
            marginBottom: 2,
          },
          ...(orden.esRetrabajo && (orden.retrabajoOrigen || []).length > 0
            ? [{ inline: false, label: "Retrabajo de", value: orden.retrabajoOrigen.map((o) => `${o.folio || "OP"} (${o.piezas} pzs)`).join(" · "), marginBottom: 2 }]
            : []),
          { inline: false, label: "Proyecto", value: orden.proyectoEjecucionId?.nombre || "—", marginBottom: 2 },
          { inline: false, label: "Fecha de inicio", value: orden.fechaInicio ? new Date(orden.fechaInicio).toLocaleDateString("es-MX") : "—", marginBottom: 2 },
        ],
      },
      {
        span: 24,
        items: [
          { label: "Esperada", value: orden.cantidadEsperada, inline: true, marginBottom: 0 },
          { label: "Final", value: orden.cantidadFinal, inline: true, marginBottom: 0 },
        ],
      },
      ...(orden.estado === 3
        ? []
        : [
            {
              span: 24,
              content: (
                <div style={{ marginTop: 4 }}>
                  <div style={{ fontSize: 11, color: "#999", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.4px", marginBottom: 2 }}>
                    Avance a Terminado
                  </div>
                  <Progress percent={avanceDe(orden)} size="small" />
                </div>
              ),
            },
          ]),
      {
        span: 24,
        content: (
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 6, marginTop: 4 }}>
            <Tooltip title="Ver">
              <ButtonItem size="small" cyan icon={<EyeOutlined />} onClick={detener(onVer)} />
            </Tooltip>
            {puedeEditar && (
              <Tooltip title="Editar">
                <ButtonItem size="small" naranja icon={<EditOutlined />} onClick={detener(onEditar)} />
              </Tooltip>
            )}
            {permisoMoverPiezas && orden.estado !== 2 && (
              <Tooltip title="Llenar (ver etapas / mover piezas)">
                <ButtonItem size="small" verde icon={<ToolOutlined />} onClick={detener(onVerEtapas)} />
              </Tooltip>
            )}
          </div>
        ),
      },
    ]}
  />
  );
};

export default TarjetaOrdenProduccionPU;
